// Single source of truth for "is this intake-form checkbox checked" in the UI.
// De server heeft dezelfde regel in functions/intakeForms/intakeFormRouting.js —
// wijzig je hier iets, wijzig het daar ook.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
// A checkbox answer is stored as the string "true" / "false"; anything else
// (empty string from an untouched field, undefined, a real boolean) counts as
// not checked.
const isCheckboxChecked = (value) => value === "true";

export default isCheckboxChecked;
